import React from "react"
import Menu, { MenuDivider, MenuItem } from "components/dialogs/Menu"

type Props = {
  viewMode: "list" | "table"
  onSetViewMode: (viewMode: "list" | "table") => void
  showStatusSummary: boolean
  onToggleStatusSummary: () => void
}

const ViewModeMenu = ({
  viewMode, onSetViewMode, showStatusSummary, onToggleStatusSummary,
}: Props) => {
  const menuItems = [
    <MenuItem
      key="classic"
      onClick={() => onSetViewMode("list")}
      selected={viewMode === "list"}
      px={10}
      color="gray.900"
    >
      Classic View
    </MenuItem>,
    <MenuItem
      key="columns"
      onClick={() => onSetViewMode("table")}
      selected={viewMode === "table"}
      px={10}
      color="gray.900"
    >
      Columns View
    </MenuItem>,
    <MenuDivider key="divider" />,
    <MenuItem
      key="showStatusSummary"
      onClick={() => !showStatusSummary && onToggleStatusSummary()}
      selected={showStatusSummary}
      px={10}
      color="gray.900"
    >
      Show Status Summary
    </MenuItem>,
    <MenuItem
      key="hideStatusSummary"
      onClick={() => showStatusSummary && onToggleStatusSummary()}
      selected={!showStatusSummary}
      px={10}
      color="gray.900"
    >
      Hide Status Summary
    </MenuItem>,
  ]

  return (
    <Menu
      buttonText="View"
      buttonVariant="outline"
      menuItems={menuItems}
      placement="bottom-end"
    />
  )
}

export default ViewModeMenu
